import {useEffect, useState} from 'react';
import {handleRemoveValueProps, OptionalInformationProps} from './type';
import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {FormikContextType, useFormikContext} from 'formik';
import SponsorFormItem from '../SponsorFormItem';
import ProductTypeBottomSheet from '../SponsorBottomSheet/ProductTypeBottomSheet';
import ProvinceBottomSheet from '../SponsorBottomSheet/ProvinceBottomSheet';
import CityBottomSheet from '../SponsorBottomSheet/CityBottomSheet';
import SponsorCustomButton from '../CustomButton';
import WaterSystemBottomSheet from '../SponsorBottomSheet/WaterSystemBottomSheet';
import {useQueryClient} from 'react-query';
import { initialValuesSponsorForm, itemForm } from '../../CreateActivePlan/type';
import useGetCitiesSponsorInformation from '../../../../services/hookService/sponsor/getCitySponsorInformation/useGetCitiesSponserInformation';

const OptionalInformation = ({
  isShowOptionalInformationPage,
  setIsShowOptionalInformationPage,
}: OptionalInformationProps) => {
  const [isShowProductTypeItems, setIsShowProductTypeItems] =
    useState<boolean>(false);
  const [isShowProvinceItems, setIsShowProvinceItems] =
    useState<boolean>(false);
  const [isShowCityItems, setIsShowCityItems] = useState<boolean>(false);
  const [isShowWaterSystemItems, setIsShowWaterSystemItems] =
    useState<boolean>(false);
  const formikProps: FormikContextType<initialValuesSponsorForm> =
    useFormikContext();
  const queryClient = useQueryClient();
  const allState = formikProps.values.state.map(item => item.id).join(',');
  const {cities, isLoading} = useGetCitiesSponsorInformation(allState);
  const handleRemoveValue = ({fieldName, itemId}: handleRemoveValueProps) => {
    formikProps.setFieldValue(
      fieldName,
      [...(formikProps.values[fieldName] as itemForm[])].filter(
        data => data.id !== itemId,
      ),
    );
  };
  useEffect(() => {
    const oldData = [...formikProps.values.city];
    if (!allState.length) {
      formikProps.setFieldValue('city', []);
    } else {
      if (!isLoading) {
        formikProps.setFieldValue('city', [
          ...oldData.filter(item => cities?.some(city => city.id === item.id)),
        ]);
      }
    }
  }, [allState, isLoading]);

  return (
    <div
      className={`w-full h-[100dvh] bg-white fixed left-0 top-[102%] fixed-transition ${
        isShowOptionalInformationPage ? 'top-0' : ''
      }`}
    >
      {/* start header */}
      <div className="w-full flex items-center justify-between p-6 shrink-0 text-md text-gray-900">
        <span>اطلاعات اختیاری</span>
        <SpanIcon
          className="icon-nameClose-remove text-2xl text-gray-700"
          onClick={() => setIsShowOptionalInformationPage(false)}
        />
      </div>
      {/* end header */}
      <div className="flex flex-col justify-between h-[calc(100%-72px)] pb-8">
        <div className="flex flex-col">
          <SponsorFormItem
            isRequired={false}
            isShowArrowIcon={true}
            arrowHandler={() => setIsShowProductTypeItems(true)}
            title="نوع محصول"
            value={formikProps.values['product']}
            removeValue={item =>
              handleRemoveValue({fieldName: 'product', itemId: item as number})
            }
          />

          <SponsorFormItem
            isRequired={false}
            isDisable={true}
            isShowArrowIcon={true}
            arrowHandler={() => setIsShowProductTypeItems(true)}
            title="کشور"
            value={{title: 'ایران', id: null}}
          />
          <SponsorFormItem
            isRequired={false}
            isShowArrowIcon={true}
            arrowHandler={() => setIsShowProvinceItems(true)}
            title="استان"
            value={formikProps.values['state']}
            removeValue={item => {
              handleRemoveValue({fieldName: 'state', itemId: item as number});
              queryClient.invalidateQueries({queryKey: ['cities']});
            }}
          />
          <SponsorFormItem
            isRequired={false}
            isShowArrowIcon={true}
            arrowHandler={() => setIsShowCityItems(true)}
            title="شهرستان"
            value={formikProps.values['city']}
            removeValue={item =>
              handleRemoveValue({fieldName: 'city', itemId: item as number})
            }
          />
          <SponsorFormItem
            isRequired={false}
            isShowArrowIcon={true}
            arrowHandler={() => setIsShowWaterSystemItems(true)}
            title="نوع آبیاری مزارع"
            value={formikProps.values['water_system']}
            removeValue={item =>
              handleRemoveValue({
                fieldName: 'water_system',
                itemId: item as number,
              })
            }
          />
        </div>
        <div className="px-8">
          <SponsorCustomButton
            outline={false}
            buttonType="button"
            title="تأیید اطلاعات"
            handler={() => setIsShowOptionalInformationPage(false)}
          />
        </div>
      </div>
      <ProductTypeBottomSheet
        show={isShowProductTypeItems}
        setShow={setIsShowProductTypeItems}
      />
      <ProvinceBottomSheet
        show={isShowProvinceItems}
        setShow={setIsShowProvinceItems}
      />
      <CityBottomSheet show={isShowCityItems} setShow={setIsShowCityItems} />
      <WaterSystemBottomSheet
        show={isShowWaterSystemItems}
        setShow={setIsShowWaterSystemItems}
      />
    </div>
  );
};

export default OptionalInformation;
